//: Did the ladders reach the PMS. A decision waits for its search to
//: close before it is sent (CU-869fb9wz6), so a pass has a fourth
//: question after composed / finished / decided: sent. One map for the
//: pass's row and for each search of the pass (CU-869fmm943).
export const PUSH_STYLE = {
	flushed:             { tone: 'ok',   label: 'sent' },
	flushed_by_deadline: { tone: 'warn', label: 'sent on deadline' },
	pending:             { tone: 'info', label: 'waiting' },
	flushing:            { tone: 'info', label: 'sending' },
	failed:              { tone: 'err',  label: 'failed' },
	// A newer search for the same office and date went out first:
	// these decisions are stale and will never be sent.
	superseded:          { tone: 'neutral', label: 'superseded' },
}
